import React, { useEffect, useState } from 'react';
import { useProfile } from 'src/models';
import { ExpiredWindow } from './expired-window';

// Profile data younger than this counts as checked: the gate's own first load
// shouldn't fetch the profile a second time.
const FRESH_FOR_MS = 5 * 1000;

/**
 * The Expired window in place of the requested page (#2779), rendered inside
 * AuthenticatedLayout by ProtectedRoute. It is never shown from cached data
 * alone: stale profile data is checked once before the window appears. Later
 * re-checks on focus run in AuthenticatedLayout (useRecheckExpiredState).
 */
const ExpiredWindowGate: React.FC = () => {
  const { query } = useProfile({ enabled: false });
  const [checked, setChecked] = useState(() => Date.now() - query.dataUpdatedAt < FRESH_FOR_MS);

  useEffect(() => {
    if (checked) {
      return;
    }

    let unmounted = false;
    // Join ProtectedRoute's mount refetch instead of cancelling it. A failed
    // check still shows the window: the last answer said expired.
    query.refetch({ cancelRefetch: false }).finally(() => {
      if (!unmounted) {
        setChecked(true);
      }
    });

    return () => {
      unmounted = true;
    };
    // Mount-only check
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return checked ? <ExpiredWindow /> : <div />;
};

export { ExpiredWindowGate };
